<template>
  <div class="loadingCompWrap">
    <img src="./loading.png" class="loading" />
    <text class="loadingTip">{{ loadingTip || 'Loading…' }}</text>
  </div>
</template>
<style scoped>
.loadingCompWrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loading {
  width: 0.57rem;
  height: 0.57rem;
  animation-name: circle;
  animation-duration: 700ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes circle {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loadingTip {
  margin-top: 0.2rem;
  font-size: 0.36rem;
  color: #9b9b9b;
  text-align: center;
  font-weight: 500;
}
</style>
<script>
export default {
  props: ['loadingTip']
}
</script>



// WEBPACK FOOTER //
// src/components/loading/index.vue